import { formatDiscount, formatPrice } from "../../../utils/price.utils";

function PriceDetail({ loading, Skeleton, currentPrice, selectedSize }) {
  return (
    <p className="price_details">
      {loading ? (
        <Skeleton width={120} />
      ) : (
        <>
          {formatPrice(currentPrice)}{" "}
          {selectedSize?.mrp && selectedSize?.discount > 0 && (
            <span className="sub-1">
              <del>{formatPrice(selectedSize.mrp)}</del> &nbsp;
              <span className="dis-sub">
                {formatDiscount(selectedSize.discount)}
              </span>{" "}
              (inc. of all taxes)
            </span>
          )}
        </>
      )}
    </p>
  )

}
export default PriceDetail;